import {
  initializeAppCheck,
  ReCaptchaV3Provider,
  getToken,
} from "firebase/app-check";
import { app } from "../firebaseConfig.js";

/**
 * Initializes Firebase AppCheck with reCAPTCHA v3 provider.
 * Returns the appCheck instance.
 */
export const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider("6LcBfXIrAAAAADFux1k8WdiDpq3sUXgY2GiBHabR"),
  isTokenAutoRefreshEnabled: true,
});

/**
 * Gets the AppCheck token for secure backend requests.
 * @returns {Promise<string>} AppCheck token
 */
export async function getAppCheckToken() {
  const appCheckTokenResponse = await getToken(appCheck, false);
  return appCheckTokenResponse.token;
}
